import { render, staticRenderFns } from "./MomentsInfinite.vue?vue&type=template&id=532937a0"
import script from "./MomentsInfinite.vue?vue&type=script&lang=js"
export * from "./MomentsInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports